"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTransformer = exports.RowTransformerValidator = void 0;
var RowTransformerValidator_1 = require("./RowTransformerValidator");
Object.defineProperty(exports, "RowTransformerValidator", {
  enumerable: true,
  get: function get() {
    return RowTransformerValidator_1.RowTransformerValidator;
  }
});
var HeaderTransformer_1 = require("./HeaderTransformer");
Object.defineProperty(exports, "HeaderTransformer", {
  enumerable: true,
  get: function get() {
    return HeaderTransformer_1.HeaderTransformer;
  }
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7QUFBU0E7RUFBQUM7RUFBQUM7SUFBQSx3REFBdUI7RUFBQTtBQUFBO0FBQ2hDO0FBQVNGO0VBQUFDO0VBQUFDO0lBQUEsNENBQWlCO0VBQUE7QUFBQSIsIm5hbWVzIjpbIk9iamVjdCIsImVudW1lcmFibGUiLCJnZXQiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL3RyYW5zZm9ybXMvaW5kZXgudHMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=